import { FC } from "react";
import { Card, Collapse, Divider, Stack } from "@mui/material";
import { useToggle } from "rooks";
import { DimensionCostAllocationCardCollapseHeader } from "@/components/pages/dimensions/components/form-drawer/components/dimension/cost-allocation/cost-allocation-card/components/DimensionCostAllocationCardCollapseHeader";
import { DimensionCostAllocationCardFilters } from "@/components/pages/dimensions/components/form-drawer/components/dimension/cost-allocation/cost-allocation-card/components/DimensionCostAllocationCardFilters";
import { DimensionCostAllocationCardAllocationType } from "@/components/pages/dimensions/components/form-drawer/components/dimension/cost-allocation/cost-allocation-card/components/DimensionCostAllocationCardAllocationType";
import { DimensionEnhancedSharedCost } from "@/store/dimensions/utils/types/common";

interface DimensionCostAllocationCardProps {
  sharedCost: DimensionEnhancedSharedCost;
}

export const DimensionCostAllocationCard: FC<
  DimensionCostAllocationCardProps
> = ({ sharedCost }) => {
  const [collapsed, toggleCollapsed] = useToggle();

  return (
    <Card variant="outlined">
      <DimensionCostAllocationCardCollapseHeader
        collapsed={collapsed}
        sharedCostId={sharedCost.id}
        sharedCostName={sharedCost.name}
        toggleCollapsed={toggleCollapsed}
      />

      <Collapse in={!collapsed}>
        <Stack spacing={1.5} p={1.5} pt={0}>
          <Divider />

          <DimensionCostAllocationCardFilters
            sharedCostId={sharedCost.id}
            sharedCostFilters={sharedCost.filter_tree}
          />

          <Divider />

          <DimensionCostAllocationCardAllocationType sharedCost={sharedCost} />
        </Stack>
      </Collapse>
    </Card>
  );
};
